import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionTimeoutService } from '../../services/session-timeout.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-session-warning-modal',
    templateUrl: './session-warning-modal.component.html',
    styleUrls: ['./session-warning-modal.component.scss']
})
export class SessionWarningModalComponent implements OnInit, OnDestroy {
    @ViewChild('sessionWarningModal', { static: false }) sessionWarningModal: ModalDirective;

    private warningSubscription: Subscription;

    constructor(private sessionTimeoutService: SessionTimeoutService) { }

    ngOnInit(): void {
        // Subscribe to warning notifications
        this.warningSubscription = this.sessionTimeoutService.showWarning$.subscribe(
            (shouldShow: boolean) => {
                if (shouldShow) {
                    this.showModal();
                } else {
                    this.hideModal();
                }
            }
        );
    }

    ngOnDestroy(): void {
        if (this.warningSubscription) {
            this.warningSubscription.unsubscribe();
        }
    }


    private showModal(): void {
        if (this.sessionWarningModal) {
            this.sessionWarningModal.show();
        }
    }

    private hideModal(): void {
        if (this.sessionWarningModal) {
            this.sessionWarningModal.hide();
        }
    }

    public onDoNotExpire(): void {
        this.sessionTimeoutService.extendSession();
        this.hideModal();
    }
}
